import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import { GridLayout, GridItem } from 'vue-grid-layout';
Vue.component('d2-grid-layout', GridLayout);
Vue.component('d2-grid-item', GridItem);
export default {
  data: function data() {
    return {
      layout: {
        layout: [{
          x: 0,
          y: 0,
          w: 4,
          h: 10,
          i: '0'
        }, {
          x: 4,
          y: 0,
          w: 2,
          h: 5,
          i: '1'
        }, {
          x: 6,
          y: 0,
          w: 4,
          h: 5,
          i: '2'
        }, {
          x: 10,
          y: 0,
          w: 2,
          h: 10,
          i: '3'
        }, {
          x: 4,
          y: 5,
          w: 4,
          h: 5,
          i: '4'
        }, {
          x: 8,
          y: 5,
          w: 2,
          h: 5,
          i: '5'
        }, {
          x: 0,
          y: 10,
          w: 8,
          h: 5,
          i: '6'
        }, {
          x: 8,
          y: 10,
          w: 4,
          h: 5,
          i: '7'
        }],
        colNum: 12,
        rowHeight: 30,
        isDraggable: true,
        isResizable: true,
        isMirrored: false,
        verticalCompact: true,
        margin: [10, 10],
        useCssTransforms: true
      }
    };
  },
  mounted: function mounted() {
    // 加载完成后显示提示
    this.showInfo();
  },
  methods: {
    log: function log() {
      var arg1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'log';

      for (var _len = arguments.length, logs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        logs[_key - 1] = arguments[_key];
      }

      if (logs.length === 0) {
        console.log(arg1);
      } else {
        console.group(arg1);
        logs.forEach(function (e) {
          console.log(e);
        });
        console.groupEnd();
      }
    },
    // 显示提示
    showInfo: function showInfo() {
      this.$notify({
        title: '提示',
        message: '你可以按住卡片拖拽改变位置；或者在每个卡片的右下角拖动，调整卡片大小'
      });
    },
    // 测试代码
    layoutUpdatedHandler: function layoutUpdatedHandler(newLayout) {
      console.group('layoutUpdatedHandler');
      newLayout.forEach(function (e) {
        console.log("{'x': ".concat(e.x, ", 'y': ").concat(e.y, ", 'w': ").concat(e.w, ", 'h': ").concat(e.h, ", 'i': '").concat(e.i, "'},"));
      });
      console.groupEnd();
    },
    resizeHandler: function resizeHandler(i, newH, newW) {
      this.log('resizeHandler', "i: ".concat(i, ", newH: ").concat(newH, ", newW: ").concat(newW));
    },
    moveHandler: function moveHandler(i, newX, newY) {
      this.log('moveHandler', "i: ".concat(i, ", newX: ").concat(newX, ", newY: ").concat(newY));
    },
    resizedHandler: function resizedHandler(i, newH, newW, newHPx, newWPx) {
      this.log('resizedHandler', "i: ".concat(i, ", newH: ").concat(newH, ", newW: ").concat(newW, ", newHPx: ").concat(newHPx, ", newWPx: ").concat(newWPx));
    },
    movedHandler: function movedHandler(i, newX, newY) {
      this.log('movedHandler', "i: ".concat(i, ", newX: ").concat(newX, ", newY: ").concat(newY));
    }
  }
};